<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';

const isShown = ref(false);

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

function handleScroll(): void {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  window.pageYOffset > 0 ? (isShown.value = true) : (isShown.value = false);
}

function handleClick(): void {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
</script>

<template>
  <KBtn
    v-if="isShown"
    priority="info"
    icon="mdi-arrow-up"
    rounded="50"
    :class="$style.goToTopBtn"
    data-testid="goToTopBtn"
    @click="handleClick"
  />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.goToTopBtn {
  position: fixed;
  right: calc(variables.$pageMarginX / 2);
  bottom: 20px;
  z-index: 1006;

  :global {
    .v-btn__content .v-icon {
      font-size: 24px;
    }
  }
}

@media print {
  .goToTopBtn {
    display: none;
  }
}
</style>
